// extracted by mini-css-extract-plugin
export var content = "_rf-1";
export var fullScreen = "_rf-0";